<template>
    <div class="add-danwei">
        <div class="search-div common-section-bg">
            <div class="shaixuan-item">
                <el-input v-model="queryParam.name" size="mini" clearable placeholder="请输入姓名" />
            </div>
            <div class="shaixuan-item">
                <el-input v-model="queryParam.phone" size="mini" clearable placeholder="请输入电话" />
            </div>
            <div class="shaixuan-item">
                <el-input v-model="queryParam.card_num" size="mini" clearable placeholder="请输入身份证号" />
            </div>
            <div class="shaixuan-item">
                <el-select
                        v-model="queryParam.shenhe_status"
                        clearable
                        filterable
                        placeholder="请选择审核状态"
                >
                <el-option label="预通过" :value="1" />
                <el-option label="已通过" :value="2" />
                <el-option label="已驳回" :value="0" />
                </el-select>
            </div>
            <div class="shaixuan-item">
                <el-button type="primary" style="background: #1890ff; border-color: #1890ff" @click="searchClick()"
                    icon="el-icon-search">
                    查询
                </el-button>
            </div>
        </div>

        <div style="background: #fff;padding-bottom: 30px;">
            <el-table v-loading="listLoading" :data="tableData" size="mini" style="width: 100%;">
                <el-table-column prop="id" label="id" width="180" />
                <el-table-column prop="user_resource.commName" label="小区" width="200" />
                <el-table-column prop="user_resource.resourceName" label="房号" width="200" />
                <el-table-column prop="name" label="名称" width="200" />
                <el-table-column label="类型" width="200">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type == 1">户主</span>
                        <span v-if="scope.row.type == 2">业主</span>
                        <span v-if="scope.row.type == 3">租户</span>
                    </template>
                </el-table-column>
                <el-table-column prop="phone" label="电话" width="200" />
                <el-table-column label="头像" minWidth="200">
                    <template slot-scope="scope">
                        <el-image style="width: 100px; height: 100px" :src="$adddom(scope.row.avatar)"
                            :preview-src-list="[$adddom(scope.row.avatar)]">
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column label="状态" minWidth="200">
                    <template slot-scope="scope">
                        <span v-if="scope.row.shenhe_status == 1">预通过</span>
                        <span v-if="scope.row.shenhe_status == 2">通过</span>
                        <span v-if="scope.row.shenhe_status == 0">驳回</span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" align="center" label="操作" width="200">
                    <template slot-scope="scope">
                        <div class="btns-wrap">
                            <el-button type="danger" style="
                                    background: #1067e0;
                                    border-color: #1067e0;
                                " @click="clickItem(1, scope.row)">审核</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <pagination v-show="total" :total="total" :page.sync="queryParam.page" :limit.sync="queryParam.size"
                @pagination="getList" />
        </div>
        <el-drawer custom-class="custom-drawer" :visible.sync="showDrawer" :close-on-press-escape="false"
            :wrapper-closable="false" :show-close="false" size="660px">
            <template slot="title">
                <div class="custom-title">
                    <div class="title-name">{{ "审核" }}</div>
                    <i class="el-icon-circle-close close-btn pointer" @click="closeDrawerFun" />
                </div>
            </template>
            <div class="custom-content">
                <el-form ref="ruleForm" :model="viewData" :rules="rules" label-width="100px">
                    <el-form-item label="审核状态：">
                        <el-select v-model="viewData.shenhe_status" clearable filterable placeholder="状态">
                            <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="驳回备注：">
                        <el-input v-model="viewData.shenhe_remark" type="textarea" />
                    </el-form-item>
                </el-form>
                <div style="width: 100%;
    background: #FFFFFF;
    -webkit-box-shadow: 0px 5px 16px 0px rgba(123, 123, 123, 0.1);
    box-shadow: 0px 5px 16px 0px rgba(123, 123, 123, 0.1);
    z-index: 10;
    left: 0;
    bottom: 0;
    padding: 20px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;">
                    <el-button style="
                            min-width: 117px;
                            background: #1067e0;
                            font-size: 16px;
                            border-color: #1067e0;
                        " size="mini" type="primary" @click="submit()">提交</el-button>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import Cookies from "js-cookie";
import fetch from "@/api/tianzheng/allfamilymember";
import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
export default {
    data() {
        return {
            id: "",
            rules:[],
            listLoading: false,
            tableData: [],
            shenhe_status: 1,
            viewData: {
                id: 0,
                shenhe_staths: 1,
                shenhe_remark: "",
            },
            statusList: [
                { id: 1, name: '预通过' },
                { id: 2, name: '通过' },
                { id: 0, name: '驳回' },
            ],
            queryParam: {
                name: "",
                phone: "",
                card_num: "",
                page: 1,
                size: 10,
            },
            total: 0,
            showDrawer: false,
        };
    },
    components: {
        Pagination,
    },
    created() { },
    mounted() {
        this.getList();
    },
    methods: {
        /* 查询tableData数据 */
        getList() {
            let that = this;
            this.listLoading = true;
            fetch.list(that.queryParam).then((res) => {
                that.listLoading = false;
                that.tableData = res.result.list;
                that.total = res.result.total;
            });
        },
        searchClick() {
            this.queryParam.page = 1;
            this.getList();
        },
        closeDrawerFun() {
            this.showDrawer = false;
        },
        /**
         * @name: 点击子项 0新增 1编辑
         * @param {*} type
         * @param {*} id
         * @return {*}
         * @desc:
         */
        clickItem(type, row) {
            let that = this;
            this.showDrawer = true;
            this.viewData = row;
            this.isEdit = type;
            // 给组件传值
            let obj = {
                type: type,
                id: row ? row.id : "",
            };
            this.$nextTick(function () {
                that.$refs.commonAdd.initFun(obj);
            });
        },
        submit() {
            var that = this;
            fetch.edit(this.viewData).then((res) => {
                that.showDrawer = false;
                that.listLoading = false;
                that.getList();
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.app-container {
    min-height: calc(100vh - 98px);
}
</style>
